<template>
  <div>
    <el-dialog :append-to-body="true" :visible.sync="logDialogVisible" title="" top="5vh" width="75%">
      <log-viewer :log="cdrLog"></log-viewer>
    </el-dialog>

    <div v-if="liveDataResults.constructor === Array || !liveDataResults">
      <div align="center" class="css-effect-blinking loading-container" v-if='!liveDataResults.length'>
        loading <i class="el-icon-loading css-effect-blinking"></i>
      </div>

      <div v-else-if="liveDataResults.length">
        <el-row class="mb-3" style="font-size: 9pt;">
          <div style="display: inline-block" class="mr-2">
            <div style="margin-top: 2px;" v-if="numberOfCalls == liveDataResults.length">
              <i class="el-icon-circle-check"></i> Completed <i class="ml-2"></i>
            </div>
            <div style="margin-top: -1px;font-size: 12pt;" v-if="numberOfCalls != liveDataResults.length">
              <i class="el-icon-loading css-effect-blinking"></i>
            </div>
          </div>
          <smartInputView :customParams="{}" :inputValue="sharedCallDetailsId" v-if="!sharedLinkView" :noEdit="true" :saveAction="{}"
         fieldName="cdr_account_link" linkText="" style="font-size: 14px;display: inline-block;margin-left: 10px;"
                          viewMode="link"></smartInputView>
        </el-row>
        <el-row style="font-size: 9pt;" class="mb-2">
          <div class="call-info-tag">
            <i class="el-icon-user"></i> {{ callTestRequest[vendorProperty]}} <i class="ml-2"></i>
          </div>

          <div class="call-info-tag">
            <i class="el-icon-top-right"></i> {{callTestRequest.destination}} <i class="ml-2"></i>
          </div>

          <div class="call-info-tag">
            <i class="el-icon-phone"></i> Caller ID {{callTestRequest.bc_caller_id_number}} <i class="ml-2"></i>
          </div>

          <span :class="idToTestStatusClass(callTestRequest.system_call_test_status_id) + ' p-1'">
              Prediction {{idToTestStatus(callTestRequest.system_call_test_status_id)}}
          </span>

          <i class="ml-2"></i>
            <el-tag type="success" style="line-height: 0;height: auto; padding: 10px">{{callTestRequest.working_calls}} </el-tag> <i class="ml-2"></i>
            <el-tag type="warning" style="line-height: 0;height: auto; padding: 10px">{{callTestRequest.fas_calls}} </el-tag> <i class="ml-2"></i>
            <el-tag type="danger" style="line-height: 0;height: auto; padding: 10px">{{callTestRequest.unconnected_calls}} </el-tag>
        </el-row>

        <el-table :data="liveDataResults" :row-class-name="tableRowClassName" id="calls-results-table"
                  style="width: 100%;font-size: 12px;">
          <el-table-column
              label="Start Time"
              prop="start_time">
            <template slot-scope="scope">
              <span class="show-live-results-data" v-html="formatTimeCell(scope.row.start_time)"></span>
            </template>
          </el-table-column>
          <el-table-column
              label="End Time"
              prop="end_time">
            <template slot-scope="scope">
              <span class="show-live-results-data" v-html="formatTimeCell(scope.row.end_time)"></span>
            </template>
          </el-table-column>
          <!--<el-table-column
              :label="(isRootOrEmployee)? 'Vendor' : 'Prefix'"
              prop="">
            <template>
              <span class="show-live-results-data">{{ callTestRequest[vendorProperty] }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="Destination"
              prop="destination">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.destination }}</span>
            </template>
          </el-table-column>-->
          <el-table-column
              label="Number"
              prop="destinationNum">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.destinationNum }}</span>
            </template>
          </el-table-column>
          <!--<el-table-column
              label="ANI"
              prop="aniNumber">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.aniNumber }}</span>
            </template>
          </el-table-column>-->
          <el-table-column
              label="RTP"
              prop="rtp">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.rtp }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="RBT"
              prop="audioRBTSrc"
              width="60">
            <template slot-scope="scope">
              <audio-button :audioSrc="scope.row.audioRBTSrc"></audio-button>
            </template>
          </el-table-column>
          <el-table-column
              label="Audio"
              prop="audioSrc"
              width="60">
            <template slot-scope="scope">
              <audio-button :audioSrc="scope.row.audioSrc"></audio-button>
            </template>
          </el-table-column>
          <el-table-column
              label="PDD"
              prop="pdd"
              width="60">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.pdd }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="Dur"
              prop="dur"
              width="50">
            <template slot-scope="scope">
              <div class="show-live-results-data">{{ scope.row.dur }}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="Codec"
              prop="used_codec"
              width="80">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.used_codec }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="SIP"
              prop="sip_term_status"
              width="60">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.sip_term_status }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="Log"
              prop="log"
              width="60">
            <template slot-scope="scope">
              <span @click="openLogDialog(scope.row)" class="pointer-cursor" style="color: #11a8ca">Log</span>
            </template>
          </el-table-column>
          <el-table-column
              label="MOS"
              prop="mos"
              width="60">
            <template slot-scope="scope">
              <span class="show-live-results-data">{{ scope.row.mos }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="w-100 text-center mb-4 pt-3" v-else>
      {{ liveDataResults }}
    </div>
  </div>
</template>

<script>
export default {
  components: {
    /*callTestStatusViewer: () => import('@/components/call-test-status-viewer/View'),*/
    smartInputView: () => import("@/components/smart-input-view/View"),
    'log-viewer': () => import('@/modules/voip-testing-panel/log-viewer/View'),
    'audio-button': () => import('@/components/audio-button/View'),
  },
  props: {
    sharedLinkView: {
      default: false
    },
    callTestRequest: {
      required: false,
      default: 0
    },
    testFinalStatus: {
      required: false,
      default: 0
    },
    numberOfCalls: {
      required: false,
      default: -1
    },
    liveDataResults: {
      required: true
    },
    broadcastPublicId: {
      required: false
    },
  },
  data() {
    return {
      logDialogVisible: false,
      cdrLog: null,
      currentDomain: process.env.VUE_APP_CURRENT_DOMAIN,
      userTestType: null,
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      isUserRoot: $store.getters['user-state/isUserRoot'],
      isUserPlatformEmployee: $store.getters['user-state/isUserPlatformEmployee'],
      isRootOrEmployee: $store.getters['user-state/isUserRoot'] || $store.getters['user-state/isUserPlatformEmployee'],
      vendorProperty: 'out_bound_prefix'
    }
  },
  beforeMount() {
    if (this.isRootOrEmployee) this.vendorProperty =  'vendor_name'

    if (this.liveDataResults.length) {
      this.userTestType = this.liveDataResults[0].user_test_type
    }
  },
  computed: {
    sharedCallDetailsId: function () {
      return this.currentDomain + '/shared/call-details/' + this.broadcastPublicId + (($store.getters['user-state/isUserMrt']) ? ('-' + Math.floor(Math.random() * 9999999)) : '')
    },
  },
  methods: {
    formatTimeCell (t) {
      /*let a = t.split(' ')
      return a[0] + "<br>" + a[1]*/
      return t
    },
    idToTestStatus (id) {
      if (id == 1) return 'Awaiting Action'
      if (id == 2) return 'Working'
      if (id == 3) return 'FAS'
      if (id == 4) return 'Unconnected'
      if (id == 5) return 'Requires Test'
      if (id == 6) return 'Pending'
      return '-'
    },
    idToTestStatusClass (id) {
      if (id == 1) return 'voip-call-test-status awaiting-action'
      if (id == 2) return 'voip-call-test-status working'
      if (id == 3) return 'voip-call-test-status fas'
      if (id == 4) return 'voip-call-test-status unconnected'
      if (id == 5) return 'voip-call-test-status requires-test'
      if (id == 6) return 'voip-call-test-status pending'
      return '-'
    },
    tableRowClassName({row, rowIndex}) {
      let r = '';
      // if (this.testFinalStatus == 2) r += 'app-bg-green-low-alfa '
      // if (this.testFinalStatus == 3) r += 'app-bg-gold-low-alfa '
      // if (this.testFinalStatus == 4) r += 'app-bg-red-low-alfa '
      /*if (row.dur > 1) {
        return 'app-bg-gold-low-alfa';
      }*/
      if (this.checkForGeneralUnconnectedPossibility(row)) return r + 'text-gray-shadow app-bg-red-low-alfa';
      if (this.checkForGeneralWorkingPossibility(row)) return r + 'text-success app-bg-green-low-alfa';
      if (this.checkForGeneralFasPossibility(row)) return r + 'text-warning text-gray-shadow -bg-gold-low-alfa';

      return '';
    },
    checkForGeneralUnconnectedPossibility($evidences) {
      let $billSeconds = $evidences['billSeconds'];
      let $pdd = $evidences['pdd'];
      let $callRTP = $evidences['remote_media_ip'];
      let $sip_term_status = $evidences['sip_term_status'];

      if (!$callRTP || ($pdd == 0 && $billSeconds == 0) || ($sip_term_status != null && $sip_term_status != 200)) return true;

      return false;
    },
    checkForGeneralFasPossibility($evidences) {
      let $billSeconds = $evidences['billSeconds'];
      let $pdd = $evidences['pdd'];
      let $fullduration = $evidences['fullduration'];
      let $progress_mediausec = $evidences['progress_mediausec'];
      let $destinationData = $evidences['user_test_type'];

      if ($destinationData == 101) {
        if ($billSeconds >= 2) return 1;
      } else {
        if ($pdd == 0 && $billSeconds > 1) return true;
        if ($fullduration == $billSeconds && $billSeconds > 0) return true;
        if ($pdd == 0 && $progress_mediausec == 0 && $billSeconds > 1) return true;
      }

      return false;
    },
    checkForGeneralWorkingPossibility($evidences) {
      let $billSeconds = $evidences['billSeconds'];
      let $pdd = $evidences['pdd'];
      let $fullduration = $evidences['fullduration'];
      let $progress_mediausec = $evidences['progress_mediausec'];
      let $destinationData = $evidences['user_test_type'];
      let $audioRBTSrc = $evidences['audioRBTSrc'];
      let callRTP = $evidences['rtp'];
      let sip_term_status = $evidences['sip_term_status'];

      if (!callRTP || callRTP == '' || callRTP == 'null' || callRTP == null || callRTP == '-') {
        return false;
      }
      if (sip_term_status != null) {
        if (sip_term_status != 200) {
          return false;
        }
      }

      // VQ Test Type
      if ($destinationData == 920) {
        if ($audioRBTSrc) return 1;
      }

      // RBT Test Type
      if ($destinationData == 101) {
        if ($billSeconds <= '1') return 1;
      }

      if ($destinationData == 100) {
        if ($pdd > 0) return 1;
      }

      return false;
    },
    openLogDialog(data) {
      this.cdrLog = JSON.parse(data.log)
      this.logDialogVisible = true
    },
  }
}
</script>

<style>
.loading-container {
  font-size: 19px;
  padding: 20px 0;
}
</style>

<style>
#calls-results-table th.is-leaf {
  padding: 0;
  /*padding-bottom: 25px;*/
}

#calls-results-table th.is-leaf:first-child .cell {
  padding: 0 !important;
}

#calls-results-table.el-table th.is-leaf .cell {}
</style>
